import { useTranslation } from 'react-i18next'
import { CheckCircle2 } from 'lucide-react'

interface RemakeAcknowledgementProps {
  acknowledged: boolean
  onAcknowledge: (value: boolean) => void
}

export function RemakeAcknowledgement({ acknowledged, onAcknowledge }: RemakeAcknowledgementProps) {
  const { t } = useTranslation()

  return (
    <label className="flex items-start gap-2 p-3 rounded-lg bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 cursor-pointer">
      <input
        type="checkbox"
        checked={acknowledged}
        onChange={(e) => onAcknowledge(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-amber-300 text-amber-600 focus:ring-amber-500"
      />
      <span className="text-sm text-amber-900 dark:text-amber-100 select-none flex items-center gap-1.5">
        {acknowledged && <CheckCircle2 className="w-4 h-4 text-amber-600 dark:text-amber-400" />}
        {t('remake.validation.acknowledgeLabel')}
      </span>
    </label>
  )
}
